import Logger from "../lib/logger"
import consumer from "./consumer"

const messagingChannel = consumer.subscriptions.create("MessagingChannel", {
  connected() {
    Logger.debug("Connected to MessagingChannel")
    this.updateOnlineStatus(true)
  },

  disconnected() {
    Logger.debug("Disconnected from MessagingChannel")
    this.updateOnlineStatus(false)
  },

  received(data) {
    Logger.debug("Received data:", data)

    switch (data.type) {
/* 
      // UI updates are now handled via Turbo Streams
      case 'new_message':
        this.handleNewMessage(data)
        break
      case 'message_updated':
        this.handleMessageUpdated(data)
        break
      case 'message_deleted':
        this.handleMessageDeleted(data)
        break
      */
      case 'user_joined':
        this.handleUserJoined(data)
        break
      case 'user_left':
        this.handleUserLeft(data)
        break
      case 'notification':
        this.handleNotification(data)
        break
    }
  },

  /*
  handleNewMessage(data) {
    // UI updates handled by Turbo Streams
  }

  handleMessageUpdated(data) {
    // UI updates handled by Turbo Streams
  }

  handleMessageDeleted(data) {
    // UI updates handled by Turbo Streams
  }
  */

  handleUserJoined(data) {
    this.showSystemMessage(data.message)
    this.updateMembersList()
  },

  handleUserLeft(data) {
    this.showSystemMessage(data.message)
    this.updateMembersList()
  },

  handleNotification(data) {
    this.showNotification(data.message)
    this.updateUnreadCount()
  },

  // Actions
  joinChannel(channelId) {
    this.perform('join_channel', { channel_id: channelId })
  },

  leaveChannel(channelId) {
    this.perform('leave_channel', { channel_id: channelId })
  },

  // Helper methods
  scrollToBottom(targetId = 'messages-container') {
    const container = document.getElementById(targetId) || document.getElementById('messages-container')
    if (container) {
      container.scrollTop = container.scrollHeight
    }
  },

  showSystemMessage(message) {
    const messagesContainer = document.getElementById('messages')
    if (messagesContainer) {
      const systemMessage = `
        <div class="system-message text-center text-muted py-2">
          <small><em>${message}</em></small>
        </div>
      `
      messagesContainer.insertAdjacentHTML('beforeend', systemMessage)
      this.scrollToBottom()
    }
  },

  updateOnlineStatus(online) {
    // Update user's online status indicator
    const statusIndicators = document.querySelectorAll(`[data-user-status="${this.getCurrentUserId()}"]`)
    statusIndicators.forEach(indicator => {
      indicator.className = online ? 'fa fa-circle text-success' : 'fa fa-circle text-secondary'
    })
  },

  updateUnreadCount() {
    // This would typically make an AJAX request to get updated counts
    // For now, we'll just trigger a page refresh of the navigation
    const unreadBadge = document.querySelector('.nav-link .badge')
    if (unreadBadge) {
      // Increment the count (simplified)
      const currentCount = parseInt(unreadBadge.textContent) || 0
      unreadBadge.textContent = currentCount + 1
      unreadBadge.style.display = 'inline'
    }
  },

  updateMembersList() {
    // Reload members list - in a real app, this would be more sophisticated
    const membersContainer = document.querySelector('.members-sidebar .card-body')
    if (membersContainer) {
      // This is a simplified approach - in production, you'd want to update specific members
      location.reload()
    }
  },

  playNotificationSound() {
    // Play a subtle notification sound using Web Audio API instead of loading external file
    try {
      // Create a simple beep sound using Web Audio API
      const audioContext = new (window.AudioContext || window.webkitAudioContext)()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()

      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)

      oscillator.frequency.setValueAtTime(800, audioContext.currentTime)
      oscillator.type = 'sine'

      gainNode.gain.setValueAtTime(0.1, audioContext.currentTime)
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1)

      oscillator.start(audioContext.currentTime)
      oscillator.stop(audioContext.currentTime + 0.1)

    } catch (e) {
      Logger.debug('Notification sound not available:', e.message)
    }
  },

  showNotification(message) {
    // Show browser notification if permission granted
    if (Notification.permission === 'granted') {
      new Notification('Nova Mensagem', {
        body: message,
        icon: '/assets/logo.png'
      })
    }
  },

  getCurrentUserId() {
    const userElement = document.querySelector('[data-current-user-id]')
    return userElement ? userElement.dataset.currentUserId : null
  },

  // Method to request notification permissions (must be called from user interaction)
  requestNotificationPermission() {
    if ('Notification' in window) {
      if (Notification.permission === 'default') {
        return Notification.requestPermission().then(permission => {
          Logger.debug('Notification permission:', permission)
          return permission
        })
      } else if (Notification.permission === 'granted') {
        Logger.debug('Notification permission already granted')
        return Promise.resolve('granted')
      } else {
        Logger.debug('Notification permission denied')
        return Promise.resolve('denied')
      }
    }
    return Promise.resolve('not-supported')
  }
})

// Setup
document.addEventListener('DOMContentLoaded', function () {
  // Don't automatically request notification permission - wait for user interaction
  if ('Notification' in window && Notification.permission === 'default') {
    Logger.debug('Notification permission not yet granted. User must interact to enable notifications.')
  }
})

export default messagingChannel